export enum Language {
	BR = 'pt-BR',
	EN = 'en-US',
	ES = 'es-ES',
	FR = 'fr-FR',
}

export enum Currency {
	BRL = 'BRL', // Brazilian Real
	USD = 'USD', // US Dollar
	EUR = 'EUR', // Euro
	GBP = 'GBP', // British Pound
	JPY = 'JPY', // Japanese Yen
	AUD = 'AUD', // Australian Dollar
	CAD = 'CAD', // Canadian Dollar
	CHF = 'CHF', // Swiss Franc
	CNY = 'CNY', // Chinese Yuan
	INR = 'INR', // Indian Rupee
	REB = 'RUB', // Russian Ruble
	ZAR = 'ZAR'  // South African Rand
}